// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { OrganizationServiceGetOrganizationListData, OrganizationServiceGetOrganizationListResponse, OrganizationServiceCreateOrganizationData, OrganizationServiceCreateOrganizationResponse, OrganizationServiceAcceptOnboardInvitationData, OrganizationServiceAcceptOnboardInvitationResponse, OrganizationServiceInviteOnboardData, OrganizationServiceInviteOnboardResponse, OrganizationServiceAcceptMemberInvitationData, OrganizationServiceAcceptMemberInvitationResponse, OrganizationServiceGetOrganizationWhiteLabelDetailsByDomainData, OrganizationServiceGetOrganizationWhiteLabelDetailsByDomainResponse, OrganizationServiceGetOrganizationData, OrganizationServiceGetOrganizationResponse, OrganizationServiceDeleteOrganizationData, OrganizationServiceDeleteOrganizationResponse, OrganizationServiceUpdateOrganizationData, OrganizationServiceUpdateOrganizationResponse, OrganizationServiceGetOrganizationAppearanceData, OrganizationServiceGetOrganizationAppearanceResponse, OrganizationServiceUpdateOrganizationAppearanceData, OrganizationServiceUpdateOrganizationAppearanceResponse, OrganizationServiceGetExternalLinkListData, OrganizationServiceGetExternalLinkListResponse, OrganizationServiceCreateExternalLinkData, OrganizationServiceCreateExternalLinkResponse, OrganizationServiceUpdateExternalLinkOrderData, OrganizationServiceUpdateExternalLinkOrderResponse, OrganizationServiceGetExternalLinkData, OrganizationServiceGetExternalLinkResponse, OrganizationServiceDeleteExternalLinkData, OrganizationServiceDeleteExternalLinkResponse, OrganizationServiceUpdateExternalLinkData, OrganizationServiceUpdateExternalLinkResponse, OrganizationServiceGetOrganizationMemberListData, OrganizationServiceGetOrganizationMemberListResponse, OrganizationServiceCreateOrganizationMemberData, OrganizationServiceCreateOrganizationMemberResponse, OrganizationServiceInviteOrganizationMembersData, OrganizationServiceInviteOrganizationMembersResponse, OrganizationServiceUpdateOrganizationMemberMfaData, OrganizationServiceUpdateOrganizationMemberMfaResponse, OrganizationServiceDeleteOrganizationMemberData, OrganizationServiceDeleteOrganizationMemberResponse, OrganizationServiceUpdateOrganizationMemberData, OrganizationServiceUpdateOrganizationMemberResponse, OrganizationServiceUpdateOrganizationMemberRoleData, OrganizationServiceUpdateOrganizationMemberRoleResponse, OrganizationServiceToggleOrganizationMfaData, OrganizationServiceToggleOrganizationMfaResponse, OrganizationServiceGetOrganizationPermissionTemplatesData, OrganizationServiceGetOrganizationPermissionTemplatesResponse, OrganizationServiceGetOrganizationRoleListData, OrganizationServiceGetOrganizationRoleListResponse, OrganizationServiceUpdateOrganizationRolesData, OrganizationServiceUpdateOrganizationRolesResponse, OrganizationServiceGetOrganizationSecretListData, OrganizationServiceGetOrganizationSecretListResponse, OrganizationServiceCreateOrganizationSecretsData, OrganizationServiceCreateOrganizationSecretsResponse, OrganizationServiceDeleteOrganizationSecretData, OrganizationServiceDeleteOrganizationSecretResponse, OrganizationServiceUpdateOrganizationSecretData, OrganizationServiceUpdateOrganizationSecretResponse } from './types.gen';

export class OrganizationServiceService {
    /**
     * get a list of organizations.
     * @param data The data for the request.
     * @param data.nameOperator
     * @param data.nameValue
     * @param data.descriptionOperator
     * @param data.descriptionValue
     * @param data.activeOperator
     * @param data.activeValue
     * @param data.isDeletedOperator
     * @param data.isDeletedValue
     * @param data.onlyOwnerInviteOperator
     * @param data.onlyOwnerInviteValue
     * @param data.onlyOwnerInviteProjectMemberOperator
     * @param data.onlyOwnerInviteProjectMemberValue
     * @param data.enableWhiteLabelOperator
     * @param data.enableWhiteLabelValue
     * @param data.capacityOperator
     * @param data.capacityValue
     * @param data.projectIdsOperator
     * @param data.projectIdsValue
     * @param data.projectGroupIdsOperator
     * @param data.projectGroupIdsValue
     * @param data.orgIdsOperator
     * @param data.orgIdsValue
     * @param data.search
     * @param data.paginationPage
     * @param data.paginationPageSize
     * @param data.sortBy
     * @param data.sortOrderBy
     * @param data.statusOperator
     * @param data.statusValue
     * @returns v1GetOrganizationListResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganizationList(data: OrganizationServiceGetOrganizationListData = {}): CancelablePromise<OrganizationServiceGetOrganizationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations',
            query: {
                'name.operator': data.nameOperator,
                'name.value': data.nameValue,
                'description.operator': data.descriptionOperator,
                'description.value': data.descriptionValue,
                'active.operator': data.activeOperator,
                'active.value': data.activeValue,
                'isDeleted.operator': data.isDeletedOperator,
                'isDeleted.value': data.isDeletedValue,
                'onlyOwnerInvite.operator': data.onlyOwnerInviteOperator,
                'onlyOwnerInvite.value': data.onlyOwnerInviteValue,
                'onlyOwnerInviteProjectMember.operator': data.onlyOwnerInviteProjectMemberOperator,
                'onlyOwnerInviteProjectMember.value': data.onlyOwnerInviteProjectMemberValue,
                'enableWhiteLabel.operator': data.enableWhiteLabelOperator,
                'enableWhiteLabel.value': data.enableWhiteLabelValue,
                'capacity.operator': data.capacityOperator,
                'capacity.value': data.capacityValue,
                'projectIds.operator': data.projectIdsOperator,
                'projectIds.value': data.projectIdsValue,
                'projectGroupIds.operator': data.projectGroupIdsOperator,
                'projectGroupIds.value': data.projectGroupIdsValue,
                'orgIds.operator': data.orgIdsOperator,
                'orgIds.value': data.orgIdsValue,
                search: data.search,
                'pagination.page': data.paginationPage,
                'pagination.pageSize': data.paginationPageSize,
                'sort.by': data.sortBy,
                'sort.orderBy': data.sortOrderBy,
                'status.operator': data.statusOperator,
                'status.value': data.statusValue
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * creates an organization.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns v1OrganizationIDResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceCreateOrganization(data: OrganizationServiceCreateOrganizationData): CancelablePromise<OrganizationServiceCreateOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * redirect to the onboarding page with email
     * @param data The data for the request.
     * @param data.key
     * @returns v1AcceptOnboardInvitationResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceAcceptOnboardInvitation(data: OrganizationServiceAcceptOnboardInvitationData = {}): CancelablePromise<OrganizationServiceAcceptOnboardInvitationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/onboarding/invitation/accept',
            query: {
                key: data.key
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * invite a client to create a new organization and its owner account by email
     * @param data The data for the request.
     * @param data.requestBody
     * @returns v1InviteOnboardResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceInviteOnboard(data: OrganizationServiceInviteOnboardData): CancelablePromise<OrganizationServiceInviteOnboardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/onboarding/invite',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * accept organization member invitation status
     * @param data The data for the request.
     * @param data.key
     * @returns v1AcceptOrgInvitationResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceAcceptMemberInvitation(data: OrganizationServiceAcceptMemberInvitationData = {}): CancelablePromise<OrganizationServiceAcceptMemberInvitationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/onboarding/member/invitation/accept',
            query: {
                key: data.key
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * get white label details by domain name
     * @param data The data for the request.
     * @param data.domain
     * @param data.authDomain
     * @returns v1WhiteLabelDetails A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganizationWhiteLabelDetailsByDomain(data: OrganizationServiceGetOrganizationWhiteLabelDetailsByDomainData = {}): CancelablePromise<OrganizationServiceGetOrganizationWhiteLabelDetailsByDomainResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/whitelabels',
            query: {
                domain: data.domain,
                authDomain: data.authDomain
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * get an organization by id.
     * @param data The data for the request.
     * @param data.id
     * @returns v1Organization A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganization(data: OrganizationServiceGetOrganizationData): CancelablePromise<OrganizationServiceGetOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{id}',
            path: {
                id: data.id
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * deletes an organization by id.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns v1DeleteOrganizationResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceDeleteOrganization(data: OrganizationServiceDeleteOrganizationData): CancelablePromise<OrganizationServiceDeleteOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * updates an organization.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns v1UpdateOrganizationResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateOrganization(data: OrganizationServiceUpdateOrganizationData): CancelablePromise<OrganizationServiceUpdateOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * get organization's appearance configs.
     * @param data The data for the request.
     * @param data.orgId
     * @returns v1OrganizationAppearanceConfig A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganizationAppearance(data: OrganizationServiceGetOrganizationAppearanceData): CancelablePromise<OrganizationServiceGetOrganizationAppearanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{orgId}/appearance',
            path: {
                orgId: data.orgId
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * updates an organization.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1UpdateAppearanceResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateOrganizationAppearance(data: OrganizationServiceUpdateOrganizationAppearanceData): CancelablePromise<OrganizationServiceUpdateOrganizationAppearanceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/appearance',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * returns a collection of organization external link
     * @param data The data for the request.
     * @param data.orgId
     * @param data.labelOperator
     * @param data.labelValue
     * @param data.hyperlinkOperator
     * @param data.hyperlinkValue
     * @param data.activeOperator
     * @param data.activeValue
     * @param data.isDeletedOperator
     * @param data.isDeletedValue
     * @param data.statusOperator
     * @param data.statusValue
     * @param data.search
     * @param data.paginationPage
     * @param data.paginationPageSize
     * @param data.sortBy
     * @param data.sortOrderBy
     * @returns v1GetExternalLinkListResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetExternalLinkList(data: OrganizationServiceGetExternalLinkListData): CancelablePromise<OrganizationServiceGetExternalLinkListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{orgId}/external-links',
            path: {
                orgId: data.orgId
            },
            query: {
                'label.operator': data.labelOperator,
                'label.value': data.labelValue,
                'hyperlink.operator': data.hyperlinkOperator,
                'hyperlink.value': data.hyperlinkValue,
                'active.operator': data.activeOperator,
                'active.value': data.activeValue,
                'isDeleted.operator': data.isDeletedOperator,
                'isDeleted.value': data.isDeletedValue,
                'status.operator': data.statusOperator,
                'status.value': data.statusValue,
                search: data.search,
                'pagination.page': data.paginationPage,
                'pagination.pageSize': data.paginationPageSize,
                'sort.by': data.sortBy,
                'sort.orderBy': data.sortOrderBy
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * creates a new organization external link
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1OrganizationIDResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceCreateExternalLink(data: OrganizationServiceCreateExternalLinkData): CancelablePromise<OrganizationServiceCreateExternalLinkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{orgId}/external-links',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * update organization external link order by oragnization id
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1UpdateExternalLinkOrderResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateExternalLinkOrder(data: OrganizationServiceUpdateExternalLinkOrderData): CancelablePromise<OrganizationServiceUpdateExternalLinkOrderResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/external-links/order',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * returns a collection of organization external link
     * @param data The data for the request.
     * @param data.orgId
     * @param data.extLinkId
     * @returns v1ExternalLink A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetExternalLink(data: OrganizationServiceGetExternalLinkData): CancelablePromise<OrganizationServiceGetExternalLinkResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{orgId}/external-links/{extLinkId}',
            path: {
                orgId: data.orgId,
                extLinkId: data.extLinkId
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * deletes an organization external link by id.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.extLinkId
     * @returns v1OrganizationIDResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceDeleteExternalLink(data: OrganizationServiceDeleteExternalLinkData): CancelablePromise<OrganizationServiceDeleteExternalLinkResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{orgId}/external-links/{extLinkId}',
            path: {
                orgId: data.orgId,
                extLinkId: data.extLinkId
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * update an existing organization external link
     * @param data The data for the request.
     * @param data.orgId
     * @param data.extLinkId
     * @param data.requestBody
     * @returns v1OrganizationIDResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateExternalLink(data: OrganizationServiceUpdateExternalLinkData): CancelablePromise<OrganizationServiceUpdateExternalLinkResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/external-links/{extLinkId}',
            path: {
                orgId: data.orgId,
                extLinkId: data.extLinkId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * get a list of organization members.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.nameOperator
     * @param data.nameValue
     * @param data.emailOperator
     * @param data.emailValue
     * @param data.phoneOperator
     * @param data.phoneValue
     * @param data.statusOperator
     * @param data.statusValue
     * @param data.accessLevelOperator
     * @param data.accessLevelValue
     * @param data.search
     * @param data.paginationPage
     * @param data.paginationPageSize
     * @param data.sortBy
     * @param data.sortOrderBy
     * @param data.expiresAt
     * @param data.orgRoleIdsOperator
     * @param data.orgRoleIdsValue
     * @param data.permissionCodesOperator
     * @param data.permissionCodesValue
     * @param data.inviteExpiresAt
     * @param data.activeOperator
     * @param data.activeValue
     * @param data.isDeletedOperator
     * @param data.isDeletedValue
     * @returns v1GetOrganizationMemberListResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganizationMemberList(data: OrganizationServiceGetOrganizationMemberListData): CancelablePromise<OrganizationServiceGetOrganizationMemberListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{orgId}/members',
            path: {
                orgId: data.orgId
            },
            query: {
                'name.operator': data.nameOperator,
                'name.value': data.nameValue,
                'email.operator': data.emailOperator,
                'email.value': data.emailValue,
                'phone.operator': data.phoneOperator,
                'phone.value': data.phoneValue,
                'status.operator': data.statusOperator,
                'status.value': data.statusValue,
                'accessLevel.operator': data.accessLevelOperator,
                'accessLevel.value': data.accessLevelValue,
                search: data.search,
                'pagination.page': data.paginationPage,
                'pagination.pageSize': data.paginationPageSize,
                'sort.by': data.sortBy,
                'sort.orderBy': data.sortOrderBy,
                expiresAt: data.expiresAt,
                'orgRoleIds.operator': data.orgRoleIdsOperator,
                'orgRoleIds.value': data.orgRoleIdsValue,
                'permissionCodes.operator': data.permissionCodesOperator,
                'permissionCodes.value': data.permissionCodesValue,
                inviteExpiresAt: data.inviteExpiresAt,
                'active.operator': data.activeOperator,
                'active.value': data.activeValue,
                'isDeleted.operator': data.isDeletedOperator,
                'isDeleted.value': data.isDeletedValue
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1CreateOrganizationMemberResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceCreateOrganizationMember(data: OrganizationServiceCreateOrganizationMemberData): CancelablePromise<OrganizationServiceCreateOrganizationMemberResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{orgId}/members',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * invites organization members by email
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1InviteOrganizationMembersReponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceInviteOrganizationMembers(data: OrganizationServiceInviteOrganizationMembersData): CancelablePromise<OrganizationServiceInviteOrganizationMembersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{orgId}/members/invite',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1UpdateOrganizationMemberMfaResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateOrganizationMemberMfa(data: OrganizationServiceUpdateOrganizationMemberMfaData): CancelablePromise<OrganizationServiceUpdateOrganizationMemberMfaResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/organizations/{orgId}/members/mfa',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * deletes an organization member by id.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.profileId
     * @param data.requestBody
     * @returns v1DeleteOrganizationMemberResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceDeleteOrganizationMember(data: OrganizationServiceDeleteOrganizationMemberData): CancelablePromise<OrganizationServiceDeleteOrganizationMemberResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{orgId}/members/{profileId}',
            path: {
                orgId: data.orgId,
                profileId: data.profileId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * updates an organization.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.profileId
     * @param data.requestBody
     * @returns v1UpdateOrganizationMemberResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateOrganizationMember(data: OrganizationServiceUpdateOrganizationMemberData): CancelablePromise<OrganizationServiceUpdateOrganizationMemberResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/members/{profileId}',
            path: {
                orgId: data.orgId,
                profileId: data.profileId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * updates an organization member role.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.profileId
     * @param data.requestBody
     * @returns v1UpdateOrganizationMemberRoleResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateOrganizationMemberRole(data: OrganizationServiceUpdateOrganizationMemberRoleData): CancelablePromise<OrganizationServiceUpdateOrganizationMemberRoleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/members/{profileId}/role',
            path: {
                orgId: data.orgId,
                profileId: data.profileId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1ToggleOrganizationMfaResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceToggleOrganizationMfa(data: OrganizationServiceToggleOrganizationMfaData): CancelablePromise<OrganizationServiceToggleOrganizationMfaResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/mfa/toggle',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * returns a collection of organization permission templates
     * @param data The data for the request.
     * @param data.orgId
     * @returns v1GetOrganizationPermissionTemplatesResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganizationPermissionTemplates(data: OrganizationServiceGetOrganizationPermissionTemplatesData): CancelablePromise<OrganizationServiceGetOrganizationPermissionTemplatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{orgId}/permission-templates',
            path: {
                orgId: data.orgId
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * returns a collection of organization role
     * @param data The data for the request.
     * @param data.orgId
     * @returns v1GetOrganizationRoleListResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganizationRoleList(data: OrganizationServiceGetOrganizationRoleListData): CancelablePromise<OrganizationServiceGetOrganizationRoleListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{orgId}/roles',
            path: {
                orgId: data.orgId
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * update an existing organization role
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1UpdateOrganizationRolesResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateOrganizationRoles(data: OrganizationServiceUpdateOrganizationRolesData): CancelablePromise<OrganizationServiceUpdateOrganizationRolesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/roles',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * returns a collection of organization secret
     * @param data The data for the request.
     * @param data.orgId
     * @returns v1GetOrganizationSecretListResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceGetOrganizationSecretList(data: OrganizationServiceGetOrganizationSecretListData): CancelablePromise<OrganizationServiceGetOrganizationSecretListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{orgId}/secrets',
            path: {
                orgId: data.orgId
            },
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * creates a new organization secret.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns v1CreateOrganizationSecretsResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceCreateOrganizationSecrets(data: OrganizationServiceCreateOrganizationSecretsData): CancelablePromise<OrganizationServiceCreateOrganizationSecretsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{orgId}/secrets',
            path: {
                orgId: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * deletes an organization secret by id.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.secretId
     * @param data.requestBody
     * @returns v1DeleteOrganizationSecretResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceDeleteOrganizationSecret(data: OrganizationServiceDeleteOrganizationSecretData): CancelablePromise<OrganizationServiceDeleteOrganizationSecretResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{orgId}/secrets/{secretId}',
            path: {
                orgId: data.orgId,
                secretId: data.secretId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
    /**
     * update an existing organization secret
     * @param data The data for the request.
     * @param data.orgId
     * @param data.secretId
     * @param data.requestBody
     * @returns v1UpdateOrganizationSecretResponse A successful response.
     * @throws ApiError
     */
    public static organizationServiceUpdateOrganizationSecret(data: OrganizationServiceUpdateOrganizationSecretData): CancelablePromise<OrganizationServiceUpdateOrganizationSecretResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{orgId}/secrets/{secretId}',
            path: {
                orgId: data.orgId,
                secretId: data.secretId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                default: 'An unexpected error response.'
            }
        });
    }
    
}